import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconVideo = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <svg
    ref={ref}
    width="38"
    height="25"
    viewBox="0 0 38 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="yfm-icon yfm-icon-video"
    {...omit(props, ["className"])}
  >
    <path
      d="M38 2.08258L29.6599 7.02898V2.19613C29.6417 0.985647 28.6522 0 27.4187 0H2.22296C1.00774 0 0 0.983376 0 2.2143V22.7857C0 23.9962 0.98722 25 2.22296 25H27.4347C28.6499 25 29.6576 24.0166 29.6576 22.7857V17.9415L37.9977 22.8993V2.08258H38ZM9.61457 20.2512V4.73065L22.3071 12.4909L9.61457 20.2512Z"
      fill="url(#paint0_linear_21100_348)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_21100_348"
        x1="-10.7665"
        y1="-0.000495465"
        x2="21.8531"
        y2="38.6331"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDDFFF" />
        <stop offset="0.424671" stopColor="#DB6FFF" />
        <stop offset="1" stopColor="#FFBA8F" />
      </linearGradient>
    </defs>
  </svg>
));

IconVideo.displayName = "IconVideo";

export default IconVideo;
